// extracted by mini-css-extract-plugin
export default {"card":"Webhook_card__CLgEh","actionButton":"Webhook_actionButton__Y-gvA"};